import api from "../configurations/http-common";

export const operlogList = async (payload) => {
    return api.securedAxios().get("/web/oper_log/page", {
        params: payload,
    });
};

export const operlogDetail = async (id) => {
    return api.securedAxios().get(`/web/oper_log/${id}`);
};

export const loginlogList = async (payload) => {
    return api.securedAxios().get("/web/login_log/page", {
        params: payload,
    });
};
